import React/*, {useState}*/ from 'react';
//import {View} from 'react-native'
import {Link} from 'react-router-dom';
import {useracc, getApi, postApi, putApi, deleteApi} from '../utils/functions';



//import Moment from 'react-moment';
import {UserContext} from '../utils/usercontext';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import './components/fontawesome/fontawesome';

//import ProgressBar from 'react-bootstrap/ProgressBar';
import ListGroup from 'react-bootstrap/ListGroup';
import Button from 'react-bootstrap/Button';
import InputGroup from 'react-bootstrap/InputGroup';
import Form from 'react-bootstrap/Form';
import FormControl from 'react-bootstrap/FormControl';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
//const {hasCommandModifier} = KeyBindingUtil;


//const Index = props => {
class Streams extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {
      show: false,
      channels: [],
      streams: [],
      

      stream: {
        id: false,
        name: '',
        contents: '',
      },
      /*pagination: {},
      uploads: {},
      drives: {},
      loaded: false,

      search: '',
      page: 1,*/
    };
    this.getStreams = this.getStreams.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.option = this.option.bind(this);
    this.addStream = this.addStream.bind(this);
    this.editStream = this.editStream.bind(this);
    this.deleteStream = this.deleteStream.bind(this);
  };

  //static contextType = UserContext;
  //loading:any = React.createRef();
  
  async componentDidMount() {
    //static contextType = AppContext;
    const value = this.context;

    //const [context, setContext] = useContext(UserContext);
    const getUser = await useracc();
    //console.log( getUser );
    //this.state.user = getUser;
    value.setUser( getUser );

    //console.log(this.context);

    //const [editorState, setEditorState] = useState('');
    
    this.getStreams();
  }

  async getStreams() {
    let x = await getApi('/api/v1/streams');
    //console.log( x.data );

    this.setState({channels: x.data.channels, streams: x.data.streams});
    //this.setState({ uploads: x.data.Uploads, drives: x.data.Drives, pagination: x.data.Pagination, loaded: true});
  }


  async handleSearch(event) {
    //console.log(event);
    //this.setState( {search: event.target.value } );
    let stream = this.state.stream;
    if( event.target.name === 'name' ) stream.name = event.target.value;
    if( event.target.name === 'contents' ) stream.contents = event.target.value;
    this.setState({stream});
  }

  async option(option, id = false) {
    let stream = this.state.stream;
    stream.id = id;
    if( id || id === 0 ) {
      stream.name = this.state.streams[id].name;
      stream.contents = this.state.streams[id].contents;
    } else {
      stream.id = false;
      stream.name = '';
      stream.contents = '';
    }
    this.setState({show: option, stream});
  }
  
  async addStream() {
    let params = new URLSearchParams();
    params.append('name', this.state.stream.name);
    params.append('contents', this.state.stream.contents);
    await postApi('/api/v1/streams', params);
    this.getStreams();
  }

  async editStream() {
    let params = new URLSearchParams();

    //console.log(this.state.streams[this.state.stream.id]);
    params.append('oldname', this.state.streams[this.state.stream.id].name);
    params.append('name', this.state.stream.name);
    params.append('contents', this.state.stream.contents);
    //params.append('channels', 'channels');

    //console.log(params);

    await putApi('/api/v1/streams', params);
    this.option(false);
    this.getStreams();
  }

  async deleteStream(id) {
    if( window.confirm("Are you sure you wish to delete this stream element?") ) {
      let params = new URLSearchParams();
      params.append('name', this.state.streams[id].name);
      //console.log(params);
      await deleteApi('/api/v1/streams', params);
      this.getStreams();
    }
  }


  render() {
    //const user = this.context;

    const channels = this.state.channels.map((e,i) => {
      //console.log(this.state.uploads[e]);
      return (
        <ListGroup.Item key={i}>
          
          
          <a href={`1`} target="_blank" rel="noreferrer">{e.name}</a>
          
        </ListGroup.Item>
      )
    });

    const streams = this.state.streams.map((e,i) => {
      //console.log(this.state.uploads[e]);
      return (
        <ListGroup.Item key={i}>
          <a href={`1`} target="_blank" rel="noreferrer">{e.name}</a>&nbsp;&nbsp;
          <span onClick={()=>this.option('edit', i)} style={{cursor: 'pointer'}}><FontAwesomeIcon icon="pen" /></span>&nbsp;
          <span onClick={()=>this.deleteStream(i)} style={{cursor: 'pointer'}}><FontAwesomeIcon icon="trash" /></span>
        </ListGroup.Item>
      )
    });

    
    

    return (
      <>
        {//this.state.loaded===true &&
     
          <div className="container-fluid">
            <Row className="gx-0">
              
              <Col xs={12} style={{textAlign: 'right'}}>
                {this.state.show === false ?
                  <Button size="sm" onClick={()=>this.option('add')}>Add Stream</Button>
                :
                  <Button size="sm" onClick={()=>this.option(false)}>Cancel</Button>
                }
              </Col>

              {this.state.show === 'add' &&
                <>
                  <Col md={6} className="">
                    <Form onSubmit={this.addStream}>
                      <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                        <Form.Label>Name</Form.Label>
                        <Form.Control name="name" type="text" value={this.state.stream.name} onChange={this.handleSearch} placeholder="Name" />
                      </Form.Group>
                      <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                        <Form.Label>Contents</Form.Label>
                        <Form.Control name="contents" as="textarea" onChange={this.handleSearch} rows={3} placeholder="Contents Location" />
                      </Form.Group>
                      <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                        <Button size="sm" onClick={this.addStream}>Create Stream</Button>
                      </Form.Group>
                    </Form>
                  </Col>
                  <Col md={6}>
                  </Col>
                </>
              }

              

              {this.state.show === 'edit' &&
                <>
                  <Col md={6} className="">
                    <Form onSubmit={this.editStream}>
                      <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                        <Form.Label>Name</Form.Label>
                        <Form.Control name="name" type="text" value={this.state.stream.name} onChange={this.handleSearch} placeholder="Name" />
                      </Form.Group>
                      <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                        <Form.Label>Contents</Form.Label>
                        <Form.Control name="contents" as="textarea" value={this.state.stream.contents} onChange={this.handleSearch} rows={3} placeholder="Contents Location" />
                      </Form.Group>
                      <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                        <Button size="sm" onClick={this.editStream}>Save Stream</Button>
                      </Form.Group>
                    </Form>
                  </Col>
                  <Col md={6}>
                  </Col>
                </>
              }
              

              <Col xs={12}>
                <h4>Channels</h4>
                <ListGroup variant="flush">
                  {channels}
                </ListGroup>
              </Col>

              <Col xs={12}>
                <h4>Twitch</h4>
                <ListGroup variant="flush">
                  {streams}
                </ListGroup>
              </Col>
            </Row>

              
          </div>
        }
     
    	</>
    );
  }
}

export default Streams;
  